module.exports = __webpack_public_path__ + "img/zht.169cab34.jpg";